import { Plaque } from '../plaque/Plaque';
import { MapHudButton } from '../map_hud_button/MapHudButton';
import ticketImg from '../../components/atomic/icons/ticket/ticket.png';
import { TicketCountText } from './TicketCountText';
import './TicketsScreenButton.css';

type TicketsScreenButtonProps = {
  onClick?: () => void;
  /** Dynamic ticket count (Figma `ticket_count_text`). */
  count?: string | number;
};

/**
 * Figma `window_ticket` (104:24687) — plaque + ticket + count.
 * Ticket (104:25085) positioned relative to plaque.
 */
export function TicketsScreenButton({ onClick, count }: TicketsScreenButtonProps) {
  return (
    <MapHudButton
      className="tickets-screen-button"
      ariaLabel={count != null ? `Билеты: ${count}` : 'Билеты'}
      onClick={onClick}
    >
      <Plaque />
      <img
        className="tickets-screen-button__ticket"
        src={ticketImg}
        alt=""
        draggable={false}
        aria-hidden
      />
      <TicketCountText count={count} />
    </MapHudButton>
  );
}
